import Vue from 'vue';
/**
 * @class
 */
class MiniStore {
  state;
  commit;
  dispatch;
  getters;
  context;
  constructor({ actions, getters, mutations, state }) {
    this.setState(state);
    this.setCommit(mutations);
    this.setDispatch(actions);
    this.setGetters(getters);
    this.context = {
      state: this.state,
      commit: this.commit,
      dispatch: this.dispatch,
      getters: this.getters,
    };
  }
  setState(state = {}) {
    this.state = Vue.observable(state);
  }

  setCommit(mutations = {}) {
    this.commit = Object.entries(mutations).reduce((a, [key, action]) => {
      a[key] = (...args) => action(this.state, ...args);
      return a;
    }, {});
  }
  setGetters(getters = {}) {
    this.getters = {};
    Object.entries(getters).forEach(([key, getter]) => {
      Object.defineProperty(this.getters, key, {
        get: () => getter(this.state),
      });
    });
  }
  setDispatch(actions = {}) {
    this.dispatch = Object.entries(actions).reduce((a, [key, action]) => {
      a[key] = (...args) => action(this.context, ...args);
      return a;
    }, {});
  }
}
/**
 * @typedef {Object} Context
 * @property {Object} actions
 * @property {Object} getters
 * @property {Object} state
 * @property {Object} mutations
 */

/**
 *
 * @param {Context} context
 */
export const createMiniStore = context => ({
  ...new MiniStore(context).context,
});
